module.exports = __webpack_public_path__ + "9fbbc809e7d6a78e03095e9f4dc7a97c.svg";